<template>
  <bl-flex-container-mv :gutter="24" align-items="center">
    <bl-flex-item-av :grow="0">
      <bl-button-av ico-name="ico_chevron_left_minor" class="basic-carousel__prev" @click="goPrev" />
    </bl-flex-item-av>
    <bl-flex-item-av :grow="1">
      <bl-flex-container-mv :gutter="24">
        <bl-flex-item-av
          v-for="position in totalItem"
          v-show="isItemShown(position)"
          :key="position"
          :col="itemWidth"
          class="basic-carousel__item"
        >
          <slot :name="`item-${position}`" />
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </bl-flex-item-av>
    <bl-flex-item-av :grow="0">
      <bl-button-av ico-name="ico_chevron_right_minor" class="basic-carousel__next" @click="goNext" />
    </bl-flex-item-av>
  </bl-flex-container-mv>
</template>
<script>
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexItemAv';
import BlButtonAv from '@bukalapak/bazaar-dweb-2/dist/components/BlButtonAv';

export default {
  name: 'BasicCarousel',

  components: {
    BlFlexContainerMv,
    BlFlexItemAv,
    BlButtonAv,
  },

  props: {
    totalItem: {
      type: Number,
      required: true,
    },

    itemPerPage: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      activePage: 1,
    };
  },

  computed: {
    itemWidth() {
      return 12 / this.itemPerPage;
    },
    maxPage() {
      return Math.ceil(this.totalItem / this.itemPerPage);
    },
  },

  watch: {
    activePage() {
      if (this.activePage > this.maxPage) {
        this.activePage = 1;
      }
      if (this.activePage < 1) {
        this.activePage = this.maxPage;
      }
    },
  },

  methods: {
    goNext() {
      this.activePage += 1;
    },
    goPrev() {
      this.activePage -= 1;
    },
    isItemShown(position) {
      const minShowPosition = (this.activePage - 1) * this.itemPerPage + 1;
      const maxShowPosition = this.activePage * this.itemPerPage;
      return position >= minShowPosition && position <= maxShowPosition;
    },
  },
};
</script>
